import Echo from 'laravel-echo';
import axios from 'axios';
import qs from 'qs';
// eslint-disable-next-line no-unused-vars
import Pusher from 'pusher-js';

const buildEcho = () => {
  return new Echo({
    broadcaster: process.env.REACT_APP_BROADCAST_DRIVER,
    key: process.env.REACT_APP_PUSHER_APP_KEY,
    cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
    encrypted: true,
    forceTLS: true,
    authorizer: (channel) => {
      return {
        authorize: (socketId, callback) => {
          axios.post('broadcasting/auth', {
            socket_id: socketId,
            channel_name: channel.name,
          }, {
            withCredentials: true,
            headers: { 'Content-Type': 'application/json' },
            baseURL: process.env.REACT_APP_API_BASE_URL,
            paramsSerializer: function (params) {
              return qs.stringify(params, { encode: true, arrayFormat: 'indices' })
            },
          })
          .then(response => {
            callback(false, response.data);
          })
          .catch(error => {
            callback(true, error);
          });
        }
      };
    },
  });
}

export const BroadcastingApi = {
  buildEcho,
};



// WEBPACK FOOTER //
// ./src/redux/api/BroadcastingApi.js